module.exports = __webpack_public_path__ + "83e99dbba09d3ee9b514104b95e9f61c.png";